import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useGetCountriesOptions } from '@savgroup-front-common/core/hooks/useGetCountriesOptions';

import AddressForm from './addressForm/AddressForm';

interface AddressManagementProps {
  onSubmit: () => void;
}

const AddressManagement: FC<AddressManagementProps> = ({ onSubmit }) => {
  const intl = useIntl();
  const countryOptions = useGetCountriesOptions(intl.locale);

  return <AddressForm countriesOptions={countryOptions} onSubmit={onSubmit} />;
};

export default AddressManagement;
